import React, { useState } from 'react';
import './Login.css';
import { loginUser } from '../services/authApi';

const Login = ({ onLoginSuccess, onToggleRegister, onForgotPassword }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await loginUser(username, password);
      
      // Store the bearer token in localStorage
      localStorage.setItem('authToken', response.access_token);
      localStorage.setItem('user', JSON.stringify(response));
      
      // Call the success callback
      onLoginSuccess(response);
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1 className="login-title">✨ AstroProfile ✨</h1>
          <p className="login-subtitle">Horoscope Chart Generator</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              👤 Username
            </label>
            <input
              type="text"
              id="username"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              🔒 Password
            </label>
            <input
              type="password"
              id="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={loading}
            />
          </div>

          {error && <div className="error-message">❌ {error}</div>}

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? '🔄 Logging in...' : '🚀 Login'}
          </button>
        </form>

        <div className="login-footer">
          <p className="footer-text">
            Don't have an account?{' '}
            <button
              className="toggle-form-btn"
              onClick={onToggleRegister}
              disabled={loading}
              type="button"
            >
              Register here
            </button>
          </p>
          <p className="footer-text">
            <button
              className="toggle-form-btn"
              onClick={onForgotPassword}
              disabled={loading}
              type="button"
              title="Reset your password"
            >
              Forgot Password?
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
